import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormatPipe,
  IconComponent,
  IsDefinedNotEmptyPipe,
  IsDefinedPipe,
  TranslatePipe,
} from '@softline/ui-core';
import { KommissionsauftragKopf } from '../../types/kommissionsauftrag';
import {
  AuthenticationContextStore,
  SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
} from '@softline/auth';
import { map } from 'rxjs';
import { Store } from '@softline/core';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'soft-picking-order',
  imports: [
    CommonModule,
    IconComponent,
    IsDefinedPipe,
    TranslatePipe,
    IsDefinedNotEmptyPipe,
    FormatPipe,
  ],
  templateUrl: './picking-order.component.html',
  styleUrl: './picking-order.component.css',
})
export class PickingOrderComponent {
  store = inject(Store);

  idanwender$ = this.store
    .observe(
      SOFTLINE_FEATURE_AUTHENTICATION_CONTEXT,
      AuthenticationContextStore.getters.data
    )
    .pipe(map((o) => (o as any).userId));

  userId = toSignal(this.idanwender$);
  pickingOrder = input.required<KommissionsauftragKopf>();

  readonly belegart = computed(() => {
    const belegart = this.pickingOrder()?.belegart;

    /**
     * F Kreditrechnung
     * B Barverkauf
     * L Lieferschein
     * KA Kassabon
     * AU Auftrag
     */

    switch (belegart) {
      case 'B':
        return 'Barverkauf';
      case 'AU':
        return 'Auftrag';
      case 'KA':
        return 'Kassabon';
      case 'L':
        return 'Lieferschein';
      case 'F':
        return 'Kreditrechnung';
      default:
        return null;
    }
  });
}
